<script>
  const SLOTS = $$props.$$slots || {};
  export let colorScheme = 'primary';
</script>

<style style="text/scss" lang="scss">
  // NOTE: the design-system/badge.scss file holds styles for badges,
  // and only applies them to badges with the mixin `bn-badge`.
  @import '../vendor/design-system.scss';

  .bn-badge {
    @include bn-badge;
  }
</style>

<div
  style={$$props.style || ''}
  class={`bn-badge ${$$props.class}`}
  class:badge-primary={colorScheme === 'primary'}
>
  <slot />

  {#if SLOTS.content}
    <slot name="content" />
  {/if}
</div>
